<template>
    <customModal :containerxxl=true :bodyxl=true :footerShow=true @closeModal="closeSDVQueryModal">
        <template #title>
            <h4 class="my-0">
                {{ $t("navigations.queries") }} 
            </h4>
        </template>
<template #body>
      <div class="text-center">
        <div v-if="!showContent">
          <div class="text-center">
            <h4>{{ $t("navigations.no queries found") }}</h4>
          </div>
        </div>
        <div v-if="!showContent || showContent" class="meta-row alert-modal-header d-flex align-items-center justify-content-end">
          <button class="alert-query alert-query-bg d-flex justify-content-center align-items-center my-1"
          type="button" 
          title="Raise Query"
          @click="gotoraiseQuary('SdvQuery')">
          
          <i class="fa fa-question-circle"></i>
        </button>    
          </div>
        <div v-if="showloader" class="spinner-overlay">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    
        <div v-else-if="showContent" class="table-responsive scrollable" >
           
          <table class="tableFixHead table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th>{{ $t("navigations.query id") }}</th>
                <th>{{ $t("navigations.query subject") }}</th>
                <th>{{ $t("navigations.query status") }}</th>
                <th>{{ $t("navigations.field name") }}</th>
                <th>{{ $t("navigations.priority") }}</th>
                <th>{{ $t("navigations.view") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="query in Querydetails" :key="query.id">
                <td>{{ query.queryId }}</td>
                <td>{{ query.query_Subject }}</td>
                <td>{{ query.queryOpenStatus }}</td>
                <td>{{ query.fieldName }}</td>
                <td>{{ query.priority }}</td>
                <td class="tdtext">
                  <a href="#" class="editicon"><i class="fa fa-eye" @click.prevent="viewforms(query.id)"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- test -->
      </div>
      
    </template>
    </customModal>

    <viewAlertQueryPopup
    v-if="showQueryAlertPopup"
    :queryid="queryid"
    @closeQuery="showQueryAlertPopup=false"
    :closedoption="closedoption"
    @applychanges="applychanges($event)"
  />
  <RaiseQueryPopup 
    v-if="showRaiseQuery"
    queryRoute = "Sdv"
    :alertId ="signalid"
    :fieldName="fieldName"
   
    @closeModal="closeQueryModal"/>

  </template>

    <script src="./ListSdvQueryModal.js"></script>

<style scoped>
.max-h-400 {
  max-height: 400px;
  overflow-y: scroll;
}
.alert-query:hover .pointer {
  visibility: visible;
  -webkit-transition:visibility 0.4s ease-in;
  transition:visibility 0.4s ease-in;
}

.alert-modal-body{
  padding: 25px;
  max-height: 60vh;
  overflow-y: auto;
}
.alert-modal-header{
  padding: 0px 3px;
  background: hsl(210, 17%, 98%);
  border-bottom: 1px solid #e9ecef;
}
.alert-modal-footer{
  padding: 5px 25px;
  background: hsl(210, 17%, 98%);
  border-top: 1px solid #e9ecef;
}
.alert-query-bg:hover{
   background: hsl(39, 100%, 50%)
}
.alert-query:hover {  
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
.alert-query .pointer {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius:0.3em;
  padding: 0.1rem 0.8rem;
  right: 33px;
  top:-17px;
  font-size:0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition:visibility 75ms ease-in;
  transition:visibility  75ms  ease-in;
  }
  .alert-icon{
  padding: 3px 6px;
  border-radius: 30px;
  text-align: center;
  font-size: 15px;
  line-height: 1.428571429;
  position: relative;

  border: 0px solid hsl(322, 46%, 50%);
}
.alert-query {
  width:32px;
  position: relative;
  height:32px;
  color:#fff;
  padding: 8px;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.2s;
  border: none;
  gap: 8px;
  font-size: 1rem;
  
}
.alert-query-bg
{
  background-color: hsl(45, 100%, 51%);
}
.alert-bdr {
  border-left: 4px solid;
}

.alert-badge-primary {
  background-color: hsl(168, 75%, 40%);
  color: hsl(0, 0%, 100%);
}
.alert-message {
        gap: 15px;
}
.header {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.scrollable {
  overflow-y: scroll;
  height: 350px;
  background-color: #ffffff;
}
.card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}
.card h5{
  font-size: 16px;
  font-weight:600;
}
.card:hover {
  transform: translateY(-5px);
}

.table th {
  font-weight: 600;
  color: #495057;
  background-color: #f8f9fa;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #e7eaec;
  line-height: 1.42857;
  padding: 4px;
  white-space: nowrap;
  vertical-align: top;
}

.table-hover tbody tr:hover {
  background-color: rgba(13, 110, 253, 0.05);
}

.badge {
  font-weight: 500;
  padding: 0.5em 0.8em;
}

.progress {
  background-color: #e9ecef;
}

.cursor-pointer {
  cursor: pointer;
}

.alert {
  border-left: 4px solid;
  margin-bottom: 4px !important;
}



.badge-pending {
  background-color: rgba(248, 172, 89, 0.15);
  color: var(--warning);
}

.badge-resolved {
  background-color: rgba(28, 132, 198, 0.15);
  color: var(--success);
}

.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.status-pending {
  background-color: var(--warning);
}

.status-resolved {
  background-color: var(--success);
}

.time-elapsed {
  font-weight: 600;
  color: var(--warning);
}



.vital-badge {
  background-color: rgb(207, 244, 252);
  color: rgb(5, 81, 96);
}

.lab-badge {
  background-color: rgba(35, 198, 200, 0.15);
  color: var(--secondary);
}

.med-badge {
  background-color: rgba(28, 132, 198, 0.15);
  color: var(--success);
}

.other-badge {
  background-color: rgba(149, 165, 166, 0.15);
  color: #95a5a6;
}

.notification-preview {
  background-color: #f8f9fa;
  border-radius: 3px;
  padding: 15px;
  border-left: 4px solid var(--warning);
  margin-top: 20px;
  font-size: 0.9rem;
}
.rounded-two {
  border-radius: 0rem 2.25rem 2.25rem 0rem !important;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 12px;
  text-align: left;
  padding: 4px 4px;
  position: sticky !important;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #e2e8f0;
}

.data-table td {
  padding: 4px 4px;
  font-size: 12px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.data-table tr:hover td {
  background: #f8fafc;
}
.custom-alert-info {
  border-radius: 0.25rem;
  padding: 0.3rem 0.5rem;
}
.spinner-overlay {
  position:relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
</style>
